import { InjectionToken } from '@angular/core';

import { Language } from './language.model';

export class SntI18nModuleConfig {
  include?: Language[];

  exclude?: string[];

  langs?: string[];

  defaultLang?: string;

  prefix?: string;

  suffix?: string;
}

export const DEFAULT_I18N_CONFIG: SntI18nModuleConfig = {
  defaultLang: 'en',
  prefix: './assets/i18n/',
  suffix: '.json',
};

export const NEW_I18N_CONFIG_TOKEN = new InjectionToken<SntI18nModuleConfig>('New config');
export const DEFAULT_I18N_CONFIG_TOKEN = new InjectionToken<SntI18nModuleConfig>('Default config');
